import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import 'bootstrap/dist/js/bootstrap.js';



ReactDOM.render(
  <App />,
  document.getElementById('root')
);

